export default __webpack_public_path__ + "static/media/g3.769094ab.jpg";